import { render, staticRenderFns } from "./SwitchLanguages.vue?vue&type=template&id=2802ea0c"
import script from "./SwitchLanguages.vue?vue&type=script&lang=js"
export * from "./SwitchLanguages.vue?vue&type=script&lang=js"
import style0 from "./SwitchLanguages.vue?vue&type=style&index=0&id=2802ea0c&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports